/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/anchor-is-valid */




import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip'
import { Box, Button } from '@mui/material';



/**
 *
 * @component
 * @param {Object} props - Recibe un objeto con las propiedades
 * @param {string} props.src - srce de la imagen a cargar.
 * @param {string} props.error - si se obtuvo error al cargar imagen.
 * @param {string} downloadLink. - Link para descargar imagen o archivo.
 * @returns {JSX.Element} 
 */

const Imagen = (props) => {

  const { src, error, downloadLink } = props



  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        // width: { xs: "100vw", sm: "70vw" },
      }}


    >
      <Box
        sx={{
          color: "#3CAEC7",
          fontSize: "1.5rem",
          fontWeight: "bold",
          fontFamily: "Roboto",
          textAlign: "center",
        }}

      >
        {downloadLink && <Button href={downloadLink} variant="text">Descargar TIF</Button>}
      </Box>
      <Box
        sx={{
          maxWidth: "100vw",

          justifyContent: "center",
          display: "flex",
        }}

      >
        <img
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
          }}
          src={src} alt="" />
      </Box>
    </Box>
  )
};



export default Imagen;